import React, { useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { addWaterSports } from "../store/slices/waterSports";
import { nameregex, priceRegex } from "../helper/regex";
import Select from "react-select";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { GrUploadOption } from "react-icons/gr";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import "react-bootstrap-typeahead/css/Typeahead.css";

const AddWaterSport = () => {
  const editor = useRef(null);
  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState([]);
  const [videos, setVideos] = useState([
    { id: Date.now(), mediaLink: "", title: "" },
  ]);
  const [place, setPlace] = useState([
    {
      id: Date.now(),
      placeName: "",
      timings: [],
      pricing: [
        {
          id: Date.now() + 1,
          price: "",
          minPax: "",
          maxPax: "",
          type: "",
        },
      ],
    },
  ]);

  const [videoErrors, setvideoErrors] = useState([]);
  const [placeErrors, setplaceErrors] = useState([]);
  const [imageError, setImageError] = useState("");
  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Enter Description",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    [],
  );

  const timeOptions = Array.from({ length: 34 }, (_, i) => {
    const hour = 3 + Math.floor(i / 2); // from 3 to 19 (3 AM to 19 = 7 PM)
    const minute = i % 2 === 0 ? "00" : "30";
    const paddedHour = hour.toString().padStart(2, "0"); // ensure 2 digits
    const label = `${paddedHour}:${minute}`;
    return { value: label, label };
  });

  /** IMAGE UPLOAD **/
  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (image.length + files.length > 10) {
      setImageError("You can upload a maximum of 10 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImage((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  const removeImage = (index) => {
    setImage((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const handleAddVideo = (e) => {
    e.preventDefault();
    setVideos([...videos, { id: Date.now(), mediaLink: "", title: "" }]);
    setvideoErrors([
      ...videoErrors,
      {
        title: "",
        mediaLink: "",
      },
    ]);
  };
  const handleAddPricing = (placeIndex) => {
    const updated = [...place];
    updated[placeIndex].pricing.push({
      id: Date.now(),
      price: "",
      minPax: "",
      maxPax: "",
      type: "",
    });
    setPlace(updated);
  };

  const handleRemovePricing = (placeIndex, pricingId) => {
    const updated = [...place];
    updated[placeIndex].pricing = updated[placeIndex].pricing.filter(
      (p) => p.id !== pricingId,
    );
    setPlace(updated);
  };

  const handlePricingChange = (placeIndex, pricingIndex, field, value) => {
    const updated = [...place];
    let pricingItem = updated[placeIndex].pricing[pricingIndex];

    if (field === "price") {
      pricingItem.price = value.replace(/\D/g, "").slice(0, 6);
    }

    if (field === "minPax") {
      pricingItem.minPax = value.replace(/\D/g, "").slice(0, 2);
    }

    if (field === "maxPax") {
      pricingItem.maxPax = value.replace(/\D/g, "").slice(0, 2);
    }

    if (field === "type") {
      pricingItem.type = value;
    }

    setPlace(updated);
  };

  const handleRemoveVideo = (id) => {
    const updatedvehicle = videos.filter((q) => q.id !== id);
    setVideos(updatedvehicle);

    const updatedErrors = videoErrors.filter(
      (_, index) => videos[index].id !== id,
    );
    setvideoErrors(updatedErrors);
  };

  const handleAddPlace = (e) => {
    e.preventDefault();
    setPlace([
      ...place,
      {
        id: Date.now(),
        placeName: "",
        price: "",
        minPax: "",
        maxPax: "",
        type: "",
        timings: [],
      },
    ]);
    setplaceErrors([
      ...placeErrors,
      {
        placeName: "",
        price: "",
        minPax: "",
        maxPax: "",
        type: "",
      },
    ]);
  };

  const handleTimingChange = (index, selected) => {
    const updatedplace = [...place];
    updatedplace[index].timings = selected ? selected.map((s) => s.value) : [];
    setPlace(updatedplace);
  };

  const handleRemovePlace = (id) => {
    const updatedplace = place.filter((q) => q.id !== id);
    setPlace(updatedplace);

    const updatedErrors = placeErrors.filter(
      (_, index) => place[index].id !== id,
    );
    setplaceErrors(updatedErrors);
  };

  const handleVideoChange = (index, field, value) => {
    const updatedVideos = [...videos];
    const updatedErrors = [...videoErrors];
    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        title: "",
        mediaLink: "",
      };
    }

    if (field === "title") {
      updatedVideos[index][field] = value;
      updatedErrors[index].title =
        value.trim() === "" ? "Please enter title" : "";
    }

    if (field === "mediaLink") {
      updatedVideos[index][field] = value;
      updatedErrors[index].mediaLink =
        value.trim() === "" ? "Please enter video link" : "";
    }
    setvideoErrors([...updatedErrors]);
    setVideos([...updatedVideos]);
  };

  const handlePlaceChange = (index, field, value) => {
    const updatedplace = [...place];
    const updatedErrors = [...placeErrors];

    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        placeName: "",
        timings: "",
      };
    }

    if (field === "placeName") {
      updatedplace[index][field] = value;
      updatedErrors[index].placeName =
        value.trim() === "" ? "Please select a place" : "";
    }

    if (field === "type") {
      updatedplace[index][field] = value;
      updatedErrors[index].type =
        value.trim() === "" ? "Please select price type" : "";
    }

    if (field === "price") {
      var sanitizedPrice = value.replace(/\D/g, "").slice(0, 5);
      updatedplace[index][field] = sanitizedPrice;
      updatedErrors[index].price =
        sanitizedPrice === "" || !priceRegex.test(sanitizedPrice)
          ? "Please enter a valid price"
          : "";
    }

    if (field === "minPax") {
      var sanitizedMin = value.replace(/\D/g, "").slice(0, 2);
      updatedplace[index][field] = sanitizedMin;
      updatedErrors[index].minPax =
        sanitizedMin === "" ? "Please enter min pax" : "";
    }

    if (field === "maxPax") {
      var sanitizedMax = value.replace(/\D/g, "").slice(0, 2);
      updatedplace[index][field] = sanitizedMax;
      updatedErrors[index].maxPax =
        sanitizedMax === "" ? "Please enter max pax" : "";
    }

    setplaceErrors([...updatedErrors]); // Ensure state updates
    setPlace([...updatedplace]);
  };

  const handleDescriptionChange = (content) => {
    setDescription(content);

    const stripHtmlTags = (html) => {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    };

    setErrors((prevErrors) => ({
      ...prevErrors,
      description:
        stripHtmlTags(content).trim().length === 0
          ? "Please enter valid description"
          : "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "name") {
      setName(value);
      validationErrors.name =
        value.trim() === "" ? "Please enter sport name" : "";
    }

    if (name === "description") {
      setDescription(value);
      validationErrors.description =
        value.trim() === "" ? "Please enter description" : "";
    }
    setErrors(validationErrors);
  };

  const validateForm = () => {
    let newErrors = {};

    // Places Validation
    if (!name || name.trim() === "") {
      newErrors.name = "Please enter sport name";
    }
    if (!description.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    const videoErrors = videos.map((item) => ({
      title: item.title === "" ? "Please enter video title" : "",
      mediaLink: item.mediaLink.trim() === "" ? "Please enter video link" : "",
    }));
    setvideoErrors(videoErrors);

    if (videoErrors.some((err) => err.title || err.mediaLink)) {
      newErrors.video = "Please fix errors in the video section";
    }

    const placeErrors = place.map((item) => {
      let pricingError = "";

      // Must have at least one slab
      if (!item.pricing || item.pricing.length === 0) {
        pricingError = "At least one pricing slab is required";
      } else {
        const validSlabs = item.pricing.filter(
          (p) =>
            p.price &&
            p.minPax &&
            p.maxPax &&
            p.type &&
            Number(p.minPax) <= Number(p.maxPax),
        );

        if (validSlabs.length === 0) {
          pricingError = "At least one valid pricing slab must be filled";
        }

        // Check for partially filled slabs
        const hasPartial = item.pricing.some(
          (p) =>
            (p.price || p.minPax || p.maxPax || p.type) &&
            (!p.price || !p.minPax || !p.maxPax || !p.type),
        );

        if (hasPartial) {
          pricingError = "Please complete all pricing slab fields";
        }
      }

      return {
        placeName: item.placeName === "" ? "Please select place" : "",
        timings:
          !Array.isArray(item.timings) || item.timings.length === 0
            ? "Please select at least one timing"
            : "",
        pricing: pricingError,
      };
    });
    setplaceErrors(placeErrors);

    if (
      placeErrors.some((err) => err.placeName || err.pricing || err.timings)
    ) {
      newErrors.place = "Please fix errors in the place section";
    }

    setErrors(newErrors);

    const isValid =
      Object.keys(newErrors).length === 0 &&
      videoErrors.every((err) => !err.title && !err.mediaLink) &&
      placeErrors.every(
        (err) => !err.placeName && !err.pricing && !err.timings,
      );

    return isValid;
  };

  const addPlaces = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      return;
    }
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const item = {
      name,
      status: 1,
      description,
      image,
      videos,
      place,
    };

    try {
      await dispatch(addWaterSports(item)).unwrap();
      navigate("/admin/watersports");
      alert("Water Sport added successfully!");
    } catch (error) {
      alert(error);
    }
  };

  const cancel = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Water Sport</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/watersports"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Water Sports
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Water Sport</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={addPlaces}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Water Sport Name"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {image.map((img, index) => (
                    <div
                      className="col-md-4 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  config={editorConfig}
                  onBlur={handleDescriptionChange}
                />
                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>

              {/* Videos Section */}
              <div className="col-md-10 mt-3">
                <label className="form-label">Videos</label>
                {videos.map((item, index) => (
                  <div
                    key={item.id}
                    className="container border p-3 mb-3 rounded"
                  >
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        className="btn btn-primary-600 me-2"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={handleAddVideo}
                      >
                        <CiCirclePlus style={{ fontSize: "25px" }} />
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary-600"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={() => handleRemoveVideo(item.id)}
                      >
                        <CiCircleMinus style={{ fontSize: "25px" }} />
                      </button>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          Video Title <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={item.title}
                          onChange={(e) =>
                            handleVideoChange(index, "title", e.target.value)
                          }
                          placeholder="Video Title"
                          className={`form-control ${
                            videoErrors[index]?.title ? "is-invalid" : ""
                          }`}
                        />
                        {videoErrors[index]?.title && (
                          <span className="error-message">
                            {videoErrors[index]?.title}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          Video Link <span className="text-danger">*</span>
                        </label>
                        <input
                          type="url"
                          name="mediaLink"
                          value={item.mediaLink}
                          onChange={(e) =>
                            handleVideoChange(
                              index,
                              "mediaLink",
                              e.target.value,
                            )
                          }
                          placeholder="Video URL"
                          className={`form-control ${
                            videoErrors[index]?.mediaLink ? "is-invalid" : ""
                          }`}
                        />
                        {videoErrors[index]?.mediaLink && (
                          <span className="error-message">
                            {videoErrors[index]?.mediaLink}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Places Section */}
              <div className="col-md-10 mt-3">
                <label className="form-label">Places</label>
                <div className="question-form"></div>
                {place.map((p, index) => (
                  <div key={p.id} className="container border p-3 mb-3 rounded">
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-primary-600 me-2"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={handleAddPlace}
                      >
                        <CiCirclePlus style={{ fontSize: "25px" }} />
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary-600"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={() => handleRemovePlace(p.id)}
                      >
                        <CiCircleMinus style={{ fontSize: "25px" }} />
                      </button>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-3">
                        <label className="form-label">
                          Place <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="placeName"
                          value={p.placeName}
                          onChange={(e) =>
                            handlePlaceChange(
                              index,
                              "placeName",
                              e.target.value,
                            )
                          }
                          placeholder="Place Name"
                          className={`form-control ${
                            placeErrors[index]?.placeName ? "is-invalid" : ""
                          }`}
                        />
                        {placeErrors[index]?.placeName && (
                          <div className="text-danger mt-2">
                            {placeErrors[index]?.placeName}
                          </div>
                        )}
                      </div>

                      <div className="col-md-9">
                        <label className="form-label">
                          Timing <span className="text-danger">*</span>
                        </label>
                        <Select
                          isMulti
                          options={timeOptions}
                          value={timeOptions.filter((t) =>
                            p.timings.includes(t.value),
                          )}
                          onChange={(selectedOptions) =>
                            handleTimingChange(index, selectedOptions)
                          }
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select time slots..."
                        />
                        {placeErrors[index]?.timings && (
                          <div className="text-danger mt-2">
                            {placeErrors[index]?.timings}
                          </div>
                        )}
                      </div>
                      <div className="col-md-12 mt-3">
                        <label className="form-label">
                          Pricing Slabs <span className="text-danger">*</span>
                        </label>
                        {placeErrors[index]?.pricing && (
                          <div className="text-danger mt-2">
                            {placeErrors[index]?.pricing}
                          </div>
                        )}
                        {p.pricing.map((priceItem, pricingIndex) => (
                          <div
                            key={priceItem.id}
                            className="border p-3 mb-3 rounded"
                          >
                            <div className="d-flex justify-content-end mb-2">
                              <button
                                type="button"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  padding: "0",
                                }}
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => handleAddPricing(index)}
                              >
                                <CiCirclePlus style={{ fontSize: "25px" }} />
                              </button>
                              <button
                                type="button"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  padding: "0",
                                }}
                                className="btn btn-sm btn-outline-danger"
                                onClick={() =>
                                  handleRemovePricing(index, priceItem.id)
                                }
                              >
                                <CiCircleMinus style={{ fontSize: "25px" }} />
                              </button>
                            </div>

                            <div className="row">
                              <div className="col-md-3">
                                <label>Price Type *</label>
                                <select
                                  className="form-select"
                                  value={priceItem.type}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "type",
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="PER_PERSON">Per Person</option>
                                  <option value="TOTAL">Total</option>
                                </select>
                              </div>

                              <div className="col-md-3">
                                <label>Price *</label>
                                <input
                                  type="number"
                                  placeholder="Enter price"
                                  className="form-control"
                                  value={priceItem.price}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "price",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>

                              <div className="col-md-3">
                                <label>Min Pax *</label>
                                <input
                                  type="number"
                                  placeholder="Enter min pax"
                                  className="form-control"
                                  value={priceItem.minPax}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "minPax",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>

                              <div className="col-md-3">
                                <label>Max Pax *</label>
                                <input
                                  type="number"
                                  placeholder="Enter max pax"
                                  className="form-control"
                                  value={priceItem.maxPax}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "maxPax",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
                onClick={cancel}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
                disabled={isDisabled}
              >
                {isDisabled ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddWaterSport;
